import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import StepAvatar from './StepAvatar';

const styles = () => ({
  root: {},
});

const SelectedStep = ({
  className,
  classes,
  step,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <StepAvatar
        step={step}
        size={'lg'}
      />
    </Box>
  );
};

SelectedStep.defaultProps = {
  className: '',
};

SelectedStep.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  step: PropTypes.object.isRequired,
};

export default withStyles(styles)(SelectedStep);
